// Used to display the 'type' of payment above the icons, initially for German checkout
export default {
  klarna: 'invoice',
  sepadirectdebit: 'direct.debit',
  directEbanking: 'transfer',
  giropay: 'transfer',
  eps: 'transfer',
};
